import classes from './Row.css'
import BaseComponent from '../../BaseComponent'

export default BaseComponent(classes.root)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Layout/Row/Row.js